import React from 'react';

import './styles.scss';

const SearchSection = ({ value, onChange }) => (
  <div className="searchSection">
    <input
      type="text"
      onChange={e => onChange(e.target.value)}
      value={value}
      // placeholder='dsfsdfdsf'
    />
    <span className="icon mmt-search" />
  </div>
);
export default SearchSection;
